import styled from 'styled-components';
import { getTextPresetCss, Variable } from '@optimus-web/common';
import {
    BadgeVariant,
    Component,
    Decision,
    getComponentVariableToken,
    SPACING,
    TEXT_PRESET_KEY,
} from '@optimus-web/local-tokens';

const getBadgeToken = getComponentVariableToken(Component.Badge, 'variant');

export const SMALL_NOTIFICATION_BADGE_SIZE = 14;
export const NOTIFICATION_BADGE_SIZE = 20;
const OFFSET_INTENSITY = 0.66;

export interface BadgeProps extends Variable<BadgeVariant> {
    children?: number | string;
}

export const BadgeElement = styled.span<BadgeProps>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    min-height: ${SMALL_NOTIFICATION_BADGE_SIZE}px;
    border-radius: ${NOTIFICATION_BADGE_SIZE}px;
    border: solid 2px ${getBadgeToken(Decision.BorderColor)};
    line-height: ${NOTIFICATION_BADGE_SIZE}px;
    ${getTextPresetCss(TEXT_PRESET_KEY['50s'])};
    min-width: ${(props) =>
        props.children !== undefined ? `${NOTIFICATION_BADGE_SIZE}` : `${SMALL_NOTIFICATION_BADGE_SIZE}`}px;
    height: ${(props) =>
        props.children !== undefined ? `${NOTIFICATION_BADGE_SIZE}` : `${SMALL_NOTIFICATION_BADGE_SIZE}`}px;
    padding: ${(props) => (props.children !== undefined ? `1px ${SPACING[50]}px` : '0')};
    background-color: ${getBadgeToken(Decision.BackgroundColor)};
    color: ${getBadgeToken(Decision.Color)};
`;

export const BadgeWrapperContainerElement = styled.div`
    position: relative;
    display: flex;
`;

export interface NotificationContainerElementProps {
    $size: number;
}

export const BadgeContainerElement = styled.div<NotificationContainerElementProps>`
    position: absolute;
    left: calc(100% - ${(props) => props.$size * OFFSET_INTENSITY}px);
    bottom: calc(100% - ${(props) => props.$size * OFFSET_INTENSITY}px);
    display: flex;
    justify-content: center;
    align-items: center;
`;
